export const fitting = `
[Machariel, Machariel - Incursions Standard]
Gyrostabilizer II
Gyrostabilizer II
Gyrostabilizer II
Gyrostabilizer II
Damage Control II
Dark Blood Reactor Control Unit

Tracking Computer II
Tracking Computer II
Multispectrum Shield Hardener II
Multispectrum Shield Hardener II
Pithum C-Type EM Shield Amplifier
500MN Quad LiF Restrained Microwarpdrive

1400mm Howitzer Artillery II
1400mm Howitzer Artillery II
1400mm Howitzer Artillery II
1400mm Howitzer Artillery II
1400mm Howitzer Artillery II
1400mm Howitzer Artillery II
1400mm Howitzer Artillery II
Small Tractor Beam I

Large EM Shield Reinforcer I
Large Core Defense Field Extender I
Large Thermal Shield Reinforcer II

Acolyte II x5
Ogre II x4

Quake L x1
Nanite Repair Paste x50
Tracking Speed Script x2
Optimal Range Script x2
`
